import { gql } from '@apollo/client';

export const ADD_JS_LOG = /* GraphQL */ `
  mutation AddJsLog($input: JsLogInput) {
    addJsLog(input: $input) {
      code
      message
      content
    }
  }
`;

export const ADD_ANNIVERSARY_PRIZE_DRAW_NUMBER = gql`
  mutation addAnniversaryPrizeDrawNumber($email: String!, $code: String!) {
    addAnniversaryPrizeDrawNumber(input: { email: $email, code: $code }) {
      number
    }
  }
`;

export const ADD_ANNIVERSARY_PRIZE_WON_DATA = gql`
  mutation addAnniversaryPrizeWonData($email: String!) {
    addAnniversaryPrizeWonData(email: $email) {
      code
    }
  }
`;

export const REVOKE_CUSTOMER_TOKEN = gql`
  mutation RevokeCustomerToken {
    revokeCustomerToken {
      result
    }
  }
`;

export const ADD_REPORTS_CLICK_EVENT = gql`
  mutation AddReportsClickEvent($ip: String!, $word: String!, $click_id: Int, $url: String) {
    addReportsClickEvent(ip: $ip, word: $word, click_id: $click_id, url: $url) {
      content
      code
      message
    }
  }
`;

export const ADD_STYLE_IN_FALL_AND_WINTER = /* GraphQL */ `
  mutation addStyleInFallAndWinter($input: StyleInFallAndWinterInput!) {
    addStyleInFallAndWinter(input: $input) {
      content
      code
      message
    }
  }
`;
